import STATIC_ROUTES from '@data/staticRoutes.json';
export const generatePageRange = (
  siblingCount: number,
  currentPage: number,
  totalPages: number
) => {
  const totalButtons = siblingCount * 2 + 1;

  let start = Math.max(1, currentPage - siblingCount);
  let end = Math.min(totalPages, currentPage + siblingCount);

  if (end - start < totalButtons - 1) {
    start = Math.max(1, end - totalButtons + 1);
  }
  if (currentPage - siblingCount < 1) {
    start = 1;
    end = Math.min(totalButtons, totalPages);
  }
  return [...Array(end - start + 1)].map((_, index) => start + index);
};

export const getPrefix = (type: string): string => {
  switch (type) {
    case 'hotel':
      return STATIC_ROUTES.hotelPathPrefix;
    case 'tour':
      return STATIC_ROUTES.tourPathPrefix;

    case 'vehicle':
      return STATIC_ROUTES.carRentalSearchPathPrefix;

    default:
      return '';
  }
};
